import React from 'react';
import { Card, Alert, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export const AIBudgetInsights = ({ insights, subscription }) => {
    return (
        <Card className="card-one">
            <Card.Header>
                <Card.Title as="h6">AI Budget Insights</Card.Title>
            </Card.Header>
            <Card.Body>
                {subscription === 'premium' && insights ? (
                    <>
                        <div className="mb-4">
                            <h6 className="fw-semibold">Spending Analysis</h6>
                            <Alert variant="info" className="d-flex align-items-center">
                                <i className="ri-lightbulb-line fs-24 me-2"></i>
                                <div>{insights.spendingAnalysis}</div>
                            </Alert>
                        </div>
                        <div className="mb-4">
                            <h6 className="fw-semibold">Budget Health</h6>
                            <Alert variant="info" className="d-flex align-items-center">
                                <i className="ri-heart-pulse-line fs-24 me-2"></i>
                                <div>{insights.budgetHealth}</div>
                            </Alert>
                        </div>
                        <div className="mb-4">
                            <h6 className="fw-semibold">Recommendations</h6>
                            <ul className="list-unstyled">
                                {insights.recommendations.map((rec, index) => (
                                    <li key={index} className="mb-2">
                                        <i className="ri-check-line text-primary me-2"></i>
                                        {rec}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div>
                            <h6 className="fw-semibold">Savings Opportunities</h6>
                            <Alert variant="success" className="d-flex align-items-center">
                                <i className="ri-money-dollar-circle-line fs-24 me-2"></i>
                                <div>{insights.savingsOpportunities}</div>
                            </Alert>
                        </div>
                    </>
                ) : (
                    <div className="text-center py-4">
                        <i className="ri-rocket-line fs-48 text-primary mb-3"></i>
                        <h5>Unlock AI-Powered Insights</h5>
                        <p className="text-muted mb-4">
                            Upgrade to Premium to get personalized budget recommendations
                            and smart spending analysis.
                        </p>
                        <Link to="/dashboard/pricing">
                            <Button variant="primary">
                                Upgrade to Premium
                                <i className="ri-arrow-right-line ms-2"></i>
                            </Button>
                        </Link>
                    </div>
                )}
            </Card.Body>
        </Card>
    );
}; 